import { Delete } from '@mui/icons-material'
import { Box, Button, useTheme } from '@mui/material'
import {
  gridFilterModelSelector,
  GridToolbarContainer,
  GridToolbarFilterButton,
  useGridApiContext,
  useGridSelector
} from '@mui/x-data-grid-pro'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type DataGridToolbarProps = {
  toolbarExtension?: React.ReactNode
  onResetFilter?: () => void
}

export const DataGridToolbar: React.FC<DataGridToolbarProps> = ({ onResetFilter, toolbarExtension }) => {
  const { typography } = useTheme()

  const { t } = useTranslation()

  const apiRef = useGridApiContext()
  const filter = useGridSelector(apiRef, gridFilterModelSelector)

  return (
    <GridToolbarContainer
      sx={{
        borderBottom: '1px solid',
        borderColor: 'rgba(224, 224, 224, 1)',
        pb: 1
      }}
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <Box>
          <GridToolbarFilterButton />
          <Button
            variant='text'
            disabled={!filter.items.length}
            startIcon={<Delete />}
            onClick={onResetFilter}
            sx={{
              padding: 1,
              ...typography.subtitle2
            }}
          >
            {t('dataGrid.clearFilters')}
          </Button>
        </Box>
        {toolbarExtension}
      </Box>
    </GridToolbarContainer>
  )
}
